export default __webpack_public_path__ + "static/montserrat-semibold-webfont-533e0f5035ec0e121a5285a949669b76.woff2";